import { render, staticRenderFns } from "./SidebarMenuLink.vue?vue&type=template&id=3a7dc0be&"
import script from "./SidebarMenuLink.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7dc0be')) {
      api.createRecord('3a7dc0be', component.options)
    } else {
      api.reload('3a7dc0be', component.options)
    }
    module.hot.accept("./SidebarMenuLink.vue?vue&type=template&id=3a7dc0be&", function () {
      api.rerender('3a7dc0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarMenu/SidebarMenuLink.vue"
export default component.exports